import React, { useEffect, useState } from "react";
import backicon from "./../../../../../../Assets/icons/backIcon.svg";
import "./index.scss";
import { useNavigate } from "react-router-dom";
import DynamicForm from "../../../../../customformComponent/customForm/DynamicForm";
import axiosInstance from "../../../../../services/api/API";
import { showCustomAlert } from "../../../../../customComponents/CustomSweetAlert";
import { showErrorAlert } from "../../../../../customComponents/CustomSweetAlert/errorsweetalert";
import Loader from "../../../../../customComponents/CustomLoader";



const AddProductFuelType = () => {
  const [formData, setFormData] = useState({});
  const navigate = useNavigate();
  const authToken = localStorage.getItem("authToken");
  const [validationErrors, setValidationErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [ userTypedd, setUserTypedd ] = useState([])
  const userType = localStorage.getItem("UserType")
  const businessPartnerId = localStorage.getItem("business_partner_id")

  useEffect(() => {
    userTypedropdown()
  },[])

  const userTypedropdown = async () => {
    try{
      const response = await axiosInstance.get("/bp-onboard/bplist",{
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      })

      const data = response.data.data.data
      const userTypeOptions = data.map(user => ({
        value: user.onboard_id,
        label:user.bp_name,
      }))
      setUserTypedd(userTypeOptions)
    }catch(error) {
      console.log(error)
    }
  }

  const handleFormSubmit = async (formData) => {

    const errors = {};
    let isValid = true;
    console.log("formdata",formData);

    FuelTypeInputs.forEach((field) => {
      if (field.required && !formData[field.name]) {
        errors[field.name] = "This field is required";
        isValid = false;
      }else if (field.required && field.validation && field.validation.pattern && !field.validation.pattern.test(formData[field.name])) {
        errors[field.name] = field.validation.message;
        isValid = false;
      }
    });

    if (!isValid) {
      setValidationErrors(errors);
      return;
    }

    showCustomAlert({
      title: "Success",
      text:"Are you sure you want to add a record in FuelType.",
      confirmButtonText: "Fuel Type added successfully.",
      icon: "success",
      confirmButtonText: "OK",
      callback: async () => {

    const payload = { 
      fuel_type_name: formData.name,
      fuel_type_desc: formData.description,
      status: formData.status=="Active"?1:0,
    }

    if (userType === "superadmin"){
      payload.business_partner_id = formData.business_partner_id;
    } else {
      payload.business_partner_id = businessPartnerId;
    }

    try {
      setLoading(true)
      const response = await axiosInstance.post('/fueltype/create', payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        }
      });

      console.log("API Response:", response.data);
       // Navigate to fuel type management page after successful submission

       if (response.status === 200) {
        navigate('/admin/manage-product/fuel-type');
      }

    } catch (error) {
      console.error('Error submitting form:', error);
      const errorMessage = error.response?.data?.message

    showErrorAlert({
      title: "Something went wrong",
      text: errorMessage || "An error occurred while processing your request.",
      callback: () => { 
        // Optional: code to execute after confirming the alert
        console.log("Error alert confirmed");
      }
    });
      // Handle error or display error message to user
    }
    finally{
      setLoading(false)
    }
  },
});
  };

  const FuelTypeInputs = [
    ...(userType === "superadmin"
      ? [
          {
            name: "business_partner_id",
            label: "Business Partner",
            type: "dropdown",
            required: true,
            options: userTypedd,
            gridClass: "col-lg-4",
            validation: {
              required: true
            },
          },
        ]
      : []),
    {
      name: "name",
      label: "Name",
      placeholder:"Enter Product Fuel Type",
      type: "text",
      required: true,
       validation: {
              required: true,
              pattern: /^[A-Za-z\s]*$/,
              message: "Only alphabets are allowed",
            },
      gridClass: "col-lg-4",
    },
    {
      name: "description",
      label: "Description",
      placeholder:"Enter Product FuelType",
      type: "text",
      required: true,
      validation: {
        required: true,
      },
      gridClass: "col-lg-4",
    },
    {
      name: "status",
      label: "Status",
      type: "dropdown",
      required: true,
      options: [
        { id: 1, label: "Active", value: "Active" },
        { id: 0, label: "Inactive", value: "Inactive" },
      ],
      gridClass: "col-lg-4",
      validation: { required: true },
    },
  ];

  return (
    <>
     <div>
    {loading ? (
      <Loader />
    ) : (
      <><div className="backbutton mt-2 mb-2" onClick={() => navigate('/admin/manage-product/fuel-type')}>
              <img src={backicon} alt="back" />
              <span className="backbtntitle">Add Fuel Type</span>
            </div><div className="form-container">
                <span className="cust-det-title mt-2 mb-2">
                  Please Enter Fuel Type Details
                </span>
                <DynamicForm
                  formConfig={FuelTypeInputs}
                  formData={formData}
                  setFormData={setFormData}
                  validationErrors={validationErrors}
                  setValidationErrors={setValidationErrors} />
              </div><div className="btncontainer mt-3">
                <button
                  onClick={() => handleFormSubmit(formData)}
                  className="submit-btn"
                >
                  Submit
                </button>
              </div></>
          )}
    </div>
    </>
  );
};

export default AddProductFuelType;
